/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { NgModule } from '@angular/core';
import { ConstructionSiteSearchComponent } from '@customers/construction-site-search/construction-site-search.component';
import { CustomersComponent } from '@customers/customers/customers.component';
import { SharedModule } from '@shared/shared.module';
import { CustomerSearchComponent } from './customer-search/customer-search.component';

@NgModule({
  declarations: [
    ConstructionSiteSearchComponent,
    CustomerSearchComponent,
    CustomersComponent
  ],
  exports: [
    ConstructionSiteSearchComponent,
    CustomerSearchComponent,
    CustomersComponent
  ],
  imports: [
    SharedModule
  ]
})
export class CustomersModule { }
